import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Icon from "@insite/mobius/Icon";
import Link from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import ChevronRight from "@ucs/Icons/ChevronRight";
import Exclamation from "@ucs/Icons/Exclamation";
import UCSColors from "@ucs/Utils/UCSColors";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const enum fields {
    destination = "destination",
    overrideTitle = "overrideTitle",
    icon = "icon"
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.destination]: LinkFieldValue;
        [fields.overrideTitle]: string;
        [fields.icon]: string;
    };
}

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => {
    const link = getLink(state, ownProps.fields.destination);
    return {
        url: link?.url,
        title: link?.title,
    };
};


type Props = OwnProps & ReturnType<typeof mapStateToProps>;

const commonStyle = {
    css: css`
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
    `,
};

const InformationHelper: React.FC<Props> = ({ url, title, fields }) => {

    const GetIcon = () => {
        switch (fields.icon) {
            case "Chevron":
                return ChevronRight;
            case "Exclamation":
                return Exclamation;
        }    
        return "";
    };

    const GetIconColor = ():string => {
        switch (fields.icon) {
            case "Chevron":
                return "primary";
            case "Exclamation":
                return UCSColors.tertiaryEY00;
        }    
        return "";
    };

    return <StyledWrapper style={{fontSize: 17, color: UCSColors.gray03}}>
        {url ? (
            <Link
                href={url}           
                icon={{
                    iconProps: {
                        color: GetIconColor(),
                        src: GetIcon(),
                        size: 16,
                        css: css`
                            margin-top: 3px;
                            margin-right: 8px;
                            &:hover {
                                color: ${GetIconColor()} !important;
                            }
                        `,
                    },
                }}
                {...commonStyle}
                hoverStyle={{ color: `${UCSColors.gray03} !important` }}
            >
                {fields.overrideTitle || title || url}
            </Link>
        ) : 
        <Typography  {...commonStyle}> 
            {fields.icon && (
                <Icon src={GetIcon()} color={GetIconColor()} size={16}  style={{marginTop: "3px", marginRight: "8px"}}></Icon>
            )} 
            {fields.overrideTitle}
        </Typography>
        }
    </StyledWrapper>
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(InformationHelper),
    definition: {
        group: "Basic",
        icon: "Link",
        fieldDefinitions: [
            {
                name: fields.destination,
                editorTemplate: "LinkField",
                defaultValue: { type: "Page", value: "" },
                fieldType: "General",
            },
            {
                name: fields.overrideTitle,
                displayName: "Display Text",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
            },
            {
                name: fields.icon,
                displayName: "Link chevron",
                editorTemplate: "RadioButtonsField",
                options: [
                    {
                        displayName: "Chevron",
                        value: "Chevron",
                    },
                    {
                        displayName: "Exclamation",
                        value: "Exclamation",
                    },
                ],
                defaultValue: "",
                fieldType: "Translatable",
                },
         
        ],
    },
};

export default widgetModule;
